<template>
    <div>
        <ul class="list-group mb-3" v-if="pacientes">
            <li class="list-group-item" :class="tipo == 'origem' ? 'list-group-item-primary' : 'list-group-item-secondary'" 
                v-for="(paciente, ipx) in pacientes" :key="ipx">
                <div class="lead">{{ tipo }}</div>
                <div>
                    <span class="text-muted mr-1">Id:</span>
                    {{paciente.id_pessoa }}
                     <span class="badge badge-light ml-2" v-if="paciente.st_origem">
                         {{ paciente.st_origem }}
                    </span>
                </div>
                <div><span class="text-muted mr-1">Paciente:</span>
                    {{paciente.st_nome }}, {{ paciente.cadastro.ch_sexo }}, {{ $util.getFormatDate(paciente.cadastro.dt_nascimento) }}
                </div>
                <div><span class="text-muted mr-1">CPF:</span>{{ paciente.cadastro.st_cpf ? $util.formatMask(paciente.cadastro.st_cpf, 'cpf') : 'Não Informado' }}</div>
                <div v-if="paciente.st_nome_social">
                    <span class="text-muted mr-1">Nome Social:</span>{{ paciente.st_nome_social }}
                </div>
                <div v-if="paciente.cadastro.st_nome_mae">
                    <span class="text-muted mr-1">Nome da Mãe:</span>{{ paciente.cadastro.st_nome_mae }}
                </div>
                <div v-if="paciente.cadastro.st_email">
                    <span class="text-muted mr-1">e-mail:</span>{{ paciente.cadastro.st_email }}
                </div>
                <div v-if="paciente.cadastro.telefones && paciente.cadastro.telefones.telefone">
                    <span class="text-muted mr-1">Telefone:</span>{{ $util.formatMask(paciente.cadastro.telefones.telefone, 'tel') }}
                </div>
                <div v-if="paciente.cadastro.telefones && paciente.cadastro.telefones.celular">
                    <span class="text-muted mr-1">Celular:</span>{{ $util.formatMask(paciente.cadastro.telefones.celular, 'cel') }}
                </div>
                <div v-if="paciente.st_id_externo">
                    <span class="text-muted mr-1">Id Externo:</span>{{ paciente.st_id_externo }}
                </div>
                <div class="my-2 d-flex justify-content-between">
                    <az-audit-log-button model="paciente" sizing="sm" :id="paciente.id_pessoa" />
                    <span class="badge badge-danger" v-if="paciente.paciente_unidade.id_paciente_duplicado">
                        <i class="fa fa-ban" aria-hidden="true"></i>
                        <div>Unificado</div>
                    </span>
                    <button type="button" class="btn btn-danger" v-else-if="tipo == 'destino'" @click="$emit('unir', paciente)"
                        :disabled="base && base.paciente_unidade && base.paciente_unidade.id_paciente_duplicado">
                        Unir com Paciente de Origem
                    </button>
                </div>
                <historico-marcacoes :historico="paciente.marcacoes" :naoalterar="true" />
            </li>
        </ul>

        

        <pre class="alert alert-warning" v-if="1 == 0">{{ pacientes }}</pre>
    </div>
</template>

<script>
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import HistoricoMarcacoes from '../../modulos/callcenter/HistoricoMarcacoes.vue';

export default {
    props: ['pacientes', 'tipo', 'base'],

    components: { 
        AzAuditLogButton, 
        HistoricoMarcacoes, 
    }
}
</script>